<template>
    <div class="footer_body_box">
        <footer-top></footer-top>
        <footer-bottom></footer-bottom>
    </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
    components: {
        footerTop: () => import("@/components/footerTop"),
        footerBottom: () => import("@/components/footerBottom")
    },
    methods: {
        ...mapActions([
            "getFooterColumn",
            "getFooterLink",
        ])
    },
    created() {
        this.getFooterColumn();
        this.getFooterLink();
    },
}
</script>

<style scoped>
/* 组件盒子 */
.footer_body_box{
    border-top: 1px solid #e7e7e7;
}
</style>
